export enum MessageSource {
    Self,
    Other,
    Bot
}